import { computed } from 'vue';

import { useBusinessUnitsStore, useProfile } from '@/store';

export function useBusinessUnits() {
  const store = useBusinessUnitsStore();
  const profile = useProfile();

  const businessUnits = computed(() => store.units);
  const hasBusinessUnits = computed(() => profile.hasBusinessUnits);
  const getNameById = (id: string) => store.getNameById(id);

  return { businessUnits, getNameById, hasBusinessUnits };
}
